/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum DeleteItemReturnCodes {
    Success = 0,
    NotAvailable = 1,
    Error = 2
}